import {Pathname} from "interfaces";
import {initialState} from "./initial-state";
import {PayloadAction, createSlice} from "@reduxjs/toolkit";

export const navigation = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    go: function (state, action: PayloadAction<Pathname>) {
      state["redirect"] = action["payload"];
    },
    clearRedirect: function (state) {
      state["redirect"] = undefined;
    },
  },
});

export default navigation["reducer"];
export const {go, clearRedirect} = navigation["actions"];
